var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      staticClass: "table",
      attrs: { data: _vm.logs, border: "", "highlight-current-row": "" },
    },
    [
      _c("el-table-column", {
        attrs: { prop: "createDate", label: _vm.$t("common.OperationTime") },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("dateFormatFilter")(
                        scope.row.createDate,
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    ) +
                    " "
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          "show-overflow-tooltip": "",
          prop: "operatorName",
          label: _vm.$t("common.OperatorName"),
        },
      }),
      _c("el-table-column", {
        attrs: {
          "show-overflow-tooltip": "",
          prop: "action",
          label: _vm.$t("common.PedagogicalOperation"),
        },
      }),
      _c("el-table-column", {
        attrs: {
          "show-overflow-tooltip": "",
          prop: "comments",
          label: _vm.$t("common.opinion"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }